

import React, { useEffect, useState } from 'react';

import { DashboardLayout } from "components";

import ic_update from "assets/images/ic_update.svg";
import ic_update_db from "assets/images/ic_update_db.svg";

import 'assets/scss/billingPortal/modules/reporting/settings.scss';
import { Button } from 'components/buttons/Button';
import { useCustomSelector } from 'hooks';
import { ListBoxTransfer } from 'components/form/ListBoxTransfer';
import useData from './hooks/useData';
import { useUpdate } from './hooks/useUpdate';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { useTabs } from 'hooks/useTabs/useTabs';
import useUpdateReportingData from '../useUpdateReportingData';
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';
import { MoreButton } from 'components/buttons/MoreButton';




export default function Settings(props) {    
    const {
        tabsDisplay, currentTabId
    } = useTabs({
        defaultTabId: "newOutlet",
        tabsDetails: [
            {
                id: "newOutlet",
                text: "New Outlet",
            },
            {
                id: "recursive",
                text: "Recursive",
            },
        ]
    });

    const {
        getFullProductDetailList_requesting,
    } = useCustomSelector("recursiveBillingSetup");

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        updateReportingDataModal,
        setIsModalVisible: setIsModalVisible_reportingData 
    } = useUpdateReportingData();

    const {
        productList, setProductList, 
        enabledProductList, setEnabledProductList,
        commission, setCommission,
        
        getEnabledProductDetailList_requesting,
    } = useData(currentTabId);

    const {
        updateProductDetails,
        isUpdateDisabled,

        addProduct_requesting,
        deleteProduct_requesting
    } = useUpdate({
        enabledProductList,
        commission,
        currentTabId
    });

    return (
        <div className={"settings"}>
            <DashboardLayout
                headerTitle={"Sales Person Commission Report"}

                middleSection={tabsDisplay}
                bodyClassName={"settings__body"}
                body={(
                    <>
                        {/* Update Reporting Modal */}
                        {updateReportingDataModal}

                        {/* Header */}
                        <div className={"body__header d-flex justify-content-between"}>
                            <div className={"header__title tableHeaderTitle "}>
                                Invoice Commission
                            </div>

                            <div className={"header__action d-flex align-items-center"}>
                                <div className={"action__main-action-wrapper"}>
                                    <Button
                                        className={"main-action-wrapper__main-action tableHeaderButtonPadding d-flex align-items-center"}
                                        handleOnClick={updateProductDetails}

                                        isLoading={addProduct_requesting || deleteProduct_requesting}
                                        isSpinnerColorPrimary

                                        isDisabled={!(userPermissions?.Internal_SalesPersonReport_View) || isUpdateDisabled}
                                        isDecoration_primaryTransparent
                                    >
                                        <>
                                            <img
                                                className={"main-action__icon"}
                                                src={ic_update}
                                            />

                                            <span className={"main-action__text tableHeaderButtonText "}>Update</span>
                                        </>
                                    </Button>
                                </div>

                                <SubmenuTooltip
                                    menuItems={[
                                        {
                                            icon: ic_update_db,
                                            label: "Update Database",
                                            isDisabled: !(userPermissions?.Internal_SalesPersonReport_Add),
                                            onClick: () => setIsModalVisible_reportingData(true),
                                        }
                                    ]}
                                >
                                    <MoreButton
                                        className={"action__more-actions"}
                                        iconClassName={"more-actions__icon"}
                                    />
                                </SubmenuTooltip>
                            </div>
                        </div>

                        {/* Content */}
                        <div className={"body__content"}>
                            {(currentTabId === "recursive")? (
                                <div className={"content__bottom-section"}>
                                    <FormInput_text
                                        className={"bottom-section__commission"}
                                        customInputClassName={"commission__input"}
                                        inputRightSideDisplayClassName={"commission__righ-side-icon d-flex align-items-center"}
                                        inputLabel={"Commission"}
                                        inputValue={commission}
                                        inputDisplayRightSide={"%"}
                                        isInputCurrencyFormat isInputOptional

                                        propagateValueBlur={(stateName, value) => {
                                            setCommission(value);
                                        }}
                                        isInputBlurHandlingRequired
                                    />
                                </div>
                            ):""}

                            <ListBoxTransfer
                                className={"content__list-box-transfer"}

                                leftBoxTitle={"Product List"}
                                leftBoxList={productList}
                                leftListBoxData_requesting={getFullProductDetailList_requesting}

                                leftActionButtonTxt={"Add"}
                                updateParentLeftBoxList={setProductList}
                                leftListBoxOptions={{
                                    listWrapperClassName: "w-100",
                                    listBodyClassName: "w-100"
                                }}

                                rightBoxTitle={"Enabled Products"}
                                rightBoxList={enabledProductList}
                                rightListBoxData_requesting={getEnabledProductDetailList_requesting}

                                rightActionButtonTxt={"Remove"}
                                updateParentRightBoxList={setEnabledProductList}
                                rightListBoxOptions={{
                                    listWrapperClassName: "w-100",
                                    listBodyClassName: "w-100"
                                }}
                            />
                        </div>
                    </>
                )}
            />
        </div>
    );
}